import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VentilatorPriceSettings, VentilatorPriceSettingsData } from '../../interface/master/Ventilator-Price-Settings';
import { VentilatorPriceSettingsAPI } from '../../api/master/ventilator-price-settings.api';

@Injectable()
export class VentilatorPriceSettingsService extends VentilatorPriceSettingsData {

  constructor(private api: VentilatorPriceSettingsAPI) {
    super();
  }

  list(url: string,data:any): Observable<VentilatorPriceSettings[]> {
    return this.api.list(url,data);
  }

  create(url: string, data:VentilatorPriceSettings): Observable<VentilatorPriceSettings> {
    return this.api.add(url,data);
  }

  update(url: string, data:VentilatorPriceSettings): Observable<VentilatorPriceSettings> {
    return this.api.update(url,data);
  }

}
